import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { useTitle, imageUrl } from "@/lib/format";
import { CategoryIcon, PageLoader } from "@/components/common";

export default function Categories() {
  useTitle("Categories");
  const [cats, setCats] = useState(null);
  useEffect(() => { api.get("/categories").then(({ data }) => setCats(data)); }, []);
  if (!cats) return <PageLoader />;
  return (
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8" data-testid="categories-page">
      <h1 className="font-heading text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl">Categories</h1>
      <p className="mt-3 max-w-xl text-slate-600">Explore every type of local service available on Bookvera.</p>
      <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {cats.map((c) => (
          <Link key={c.id} to={`/services?category=${c.slug}`} data-testid={`categories-item-${c.slug}`} className="group overflow-hidden rounded-2xl border border-slate-200 bg-white transition-shadow hover:shadow-lg">
            <div className="aspect-[16/10] overflow-hidden bg-slate-100">
              {c.image && <img src={imageUrl(c.image)} alt={c.name} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />}
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2 text-sky-700"><CategoryIcon name={c.icon} /><span className="text-xs font-semibold uppercase tracking-wider">{c.provider_count} providers</span></div>
              <h2 className="mt-2 font-heading text-lg font-semibold text-slate-900">{c.name}</h2>
              <p className="mt-1 text-sm text-slate-500">{c.description}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-sky-700 transition-all group-hover:gap-2">Browse <ArrowRight className="h-4 w-4" /></span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
